import { Flyer } from './GetFlyers';
import { Location } from './GetUserPreferences';
import { PaginationOptions } from './Pagination';

export enum OwningTypeEnum {
  district = 'district', //For School or district flyers
  organization = 'organization', //For community flyers
}

export enum FlyerboardTimeFrame {
  ThisWeek = 'ThisWeek',
  LastWeek = 'LastWeek',
}

export type AllFlyerFilters = {
  owningType?: OwningTypeEnum;
  schoolIds: number[];
  districtId?: number;
  categories?: string[];
  searchQuery?: string;
  format?: string;
  allDistrictSchools?: boolean;
  isCommunityFree?: boolean;
  isDistrictWidePosting?: boolean;
  isNew?: boolean;
  grades?: string[];
  isNewAndUnread?: boolean;
  isExpired?: boolean;
  isFavorite?: boolean;
  totalOnly?: boolean;
  isRemoved?: boolean;
  isInMySchool?: boolean;
  communityLocation?: Location;
  communityRadius?: number;
  newFlyerboardTimeFrame?: FlyerboardTimeFrame;
  includeExpandedCommunity?: Boolean;
  totalsOnly?: boolean;
};

export type Facet = {
  key: String;
  count: number;
};

export type Facets = {
  categories: Facet[];
  grades: Facet[];
  priceType: Facet[];
  owningType: Facet[];
};

export type FlyerCardThumbnail = Pick<
  Flyer,
  | 'flyerId'
  | 'startDate'
  | 'endDate'
  | 'submittedAt'
  | 'districtId'
  | 'title'
  | 'status'
  | 'frontImageUrl'
  | 'isFavorite'
  | 'isRead'
  | 'grades'
  | 'criticalDate'
  | 'categories'
  | 'type'
  | 'minTargetGradeOrAge'
  | 'maxTargetGradeOrAge'
  | 'schoolCount'
  | 'pages'
  | 'email'
  | 'isExpandedCommunity'
  | 'titleTranslations'
  | 'isCommunityFree'
  | 'ctas'
  | 'pages'
> & {
  org?: {
    name: string;
  };
};

export type GetAllFlyersResponse = {
  getAllFlyers: {
    items: FlyerCardThumbnail[];
    pagination: PaginationOptions;
  };
};

export type GetFacetsResponse = {
  getFacets: {
    facets: Facets;
    pagination: {
      total: number;
    };
  };
};

export type GetAllFlyersInput = {
  filters: AllFlyerFilters;
  pagination: {
    pageNumber: number;
    pageSize: number;
  };
  sort?: {
    sortBy: string;
  };
};

export type GetAllFlyersVars = {
  input: GetAllFlyersInput;
};
